// tslint:disable
// cspell:disable
import * as React from 'react';

import { TableData } from '../components/agent/agent-types';
import { TableFeedPreview } from '../components/agent/table-feed-preview';

// Sample table 1: Candidates with entity IDs
const candidatesTable: TableData = {
    title: 'Top Candidates for Senior Engineer Role',
    columns: [
        { id: 'name', label: 'Candidate Name' },
        { id: 'experience', label: 'Years Experience' },
        { id: 'skills', label: 'Key Skills' },
        { id: 'currentJob', label: 'Current Position' },
        { id: 'location', label: 'Location' }
    ],
    sortableColumns: ['experience'],
    rows: [
        {
            name: {
                displayValue: 'John Smith',
                entityType: 'candidate' as const,
                entityId: { personId: 'p123', jobId: 'j456' }
            },
            experience: 8,
            skills: 'React, TypeScript, Node.js',
            currentJob: {
                displayValue: 'Senior Engineer at TechCorp',
                entityType: 'job' as const,
                entityId: 'j789'
            },
            location: 'San Francisco, CA'
        },
        {
            name: {
                displayValue: 'Jane Doe',
                entityType: 'candidate' as const,
                entityId: { personId: 'p456', jobId: 'j456' }
            },
            experience: 6,
            skills: 'Python, Django, PostgreSQL',
            currentJob: {
                displayValue: 'Engineer at StartupXYZ',
                entityType: 'job' as const,
                entityId: 'j790'
            },
            location: 'New York, NY'
        },
        {
            name: {
                displayValue: 'Alice Johnson',
                entityType: 'candidate' as const,
                entityId: { personId: 'p789', jobId: 'j456' }
            },
            experience: 10,
            skills: 'Java, Spring Boot, Kubernetes',
            currentJob: {
                displayValue: 'Principal Engineer at BigTech',
                entityType: 'job' as const,
                entityId: 'j791'
            },
            location: 'Seattle, WA'
        },
        {
            name: {
                displayValue: 'Bob Williams',
                entityType: 'candidate' as const,
                entityId: { personId: 'p012', jobId: 'j456' }
            },
            experience: 5,
            skills: 'Go, Docker, AWS',
            currentJob: null,
            location: 'Austin, TX'
        }
    ]
};

// Sample table 2: Jobs by client
const jobsTable: TableData = {
    title: 'Open Job Requisitions by Client',
    columns: [
        { id: 'client', label: 'Client' },
        { id: 'jobTitle', label: 'Job Title' },
        { id: 'openDate', label: 'Opened' },
        { id: 'candidates', label: 'Candidates' },
        { id: 'status', label: 'Status' }
    ],
    sortableColumns: ['openDate', 'candidates'],
    rows: [
        {
            client: {
                displayValue: 'TechCorp Inc',
                entityType: 'client' as const,
                entityId: 'c111'
            },
            jobTitle: {
                displayValue: 'Senior Full Stack Engineer',
                entityType: 'job' as const,
                entityId: 'j456'
            },
            openDate: '2025-01-15',
            candidates: 12,
            status: 'Active'
        },
        {
            client: {
                displayValue: 'StartupXYZ',
                entityType: 'client' as const,
                entityId: 'c222'
            },
            jobTitle: {
                displayValue: 'DevOps Lead',
                entityType: 'job' as const,
                entityId: 'j457'
            },
            openDate: '2025-02-01',
            candidates: 8,
            status: 'Active'
        },
        {
            client: {
                displayValue: 'BigTech Solutions',
                entityType: 'client' as const,
                entityId: 'c333'
            },
            jobTitle: {
                displayValue: 'ML Engineer',
                entityType: 'job' as const,
                entityId: 'j458'
            },
            openDate: '2024-12-10',
            candidates: 25,
            status: 'On Hold'
        }
    ]
};

// Sample table 3: Large dataset for pagination testing
const largeTable: TableData = {
    title: 'All Active Candidates (50 total)',
    columns: [
        { id: 'id', label: 'ID' },
        { id: 'name', label: 'Name' },
        { id: 'email', label: 'Email' },
        { id: 'score', label: 'Match Score' }
    ],
    sortableColumns: ['score', 'name'],
    rows: Array.from({ length: 50 }, (_, i) => ({
        id: `C${String(i + 1).padStart(3, '0')}`,
        name: `Candidate ${i + 1}`,
        email: `candidate${i + 1}@example.com`,
        score: Math.floor(Math.random() * 100)
    }))
};

// Sample table 4: Mixed data types
const mixedDataTable: TableData = {
    title: 'Job Performance Metrics',
    columns: [
        { id: 'metric', label: 'Metric' },
        { id: 'value', label: 'Value' },
        { id: 'change', label: 'Change %' },
        { id: 'isGood', label: 'Trending Up' },
        { id: 'notes', label: 'Notes' }
    ],
    rows: [
        {
            metric: 'Time to Fill',
            value: 45,
            change: -12.5,
            isGood: true,
            notes: 'Improved from last quarter'
        },
        {
            metric: 'Candidate Quality',
            value: 8.5,
            change: 5.2,
            isGood: true,
            notes: null
        },
        {
            metric: 'Offer Acceptance Rate',
            value: 72,
            change: -3.1,
            isGood: false,
            notes: 'Market competition high'
        },
        {
            metric: 'Interview-to-Hire Ratio',
            value: 4.2,
            change: 0,
            isGood: undefined,
            notes: 'Stable'
        }
    ]
};

const a16ztestTable: TableData = {
    title: 'Clients Funded by Andreessen Horowitz (a16z)',
    columns: [
        {
            id: 'client',
            label: 'Client Name'
        },
        {
            id: 'website',
            label: 'Website'
        },
        {
            id: 'totalFunding',
            label: 'Total a16z Funding'
        },
        {
            id: 'stages',
            label: 'Funding Stages'
        }
    ],
    rows: [
        {
            client: {
                displayValue: 'Robinhood',
                entityType: 'client',
                entityId: 'b1k5edk3'
            },
            website: '—',
            totalFunding: '$4.12B',
            stages: 'Seed, Series G, Series H, PE'
        },
        {
            client: {
                displayValue: 'Coinbase',
                entityType: 'client',
                entityId: '1j7vojg8'
            },
            website: '—',
            totalFunding: '$400M',
            stages: 'Series B, Series E, Secondary Market, Unknown'
        },
        {
            client: {
                displayValue: 'KoBold Metals',
                entityType: 'client',
                entityId: '827l8ogz'
            },
            website: 'koboldmetals.com',
            totalFunding: '$965M',
            stages: 'Series A, Series B, Series C'
        },
        {
            client: {
                displayValue: 'Fivetran',
                entityType: 'client',
                entityId: 'b9k4qxg4'
            },
            website: '—',
            totalFunding: '$709M',
            stages: 'Series B, Series C, Series D'
        },
        {
            client: {
                displayValue: 'Dapper Labs',
                entityType: 'client',
                entityId: 'wp7wj3gv'
            },
            website: 'dapperlabs.com',
            totalFunding: '$596M',
            stages: 'Series A, Series B, Series C, Series D'
        },
        {
            client: {
                displayValue: 'Divvy Homes',
                entityType: 'client',
                entityId: '3x7m1e78'
            },
            website: '—',
            totalFunding: '$363M',
            stages: 'Series A, Series B, Series C, Series D'
        },
        {
            client: {
                displayValue: 'Lyft',
                entityType: 'client',
                entityId: 'wq7dmm7m'
            },
            website: '—',
            totalFunding: '$310M',
            stages: 'Series C, Series D'
        },
        {
            client: {
                displayValue: 'Carta',
                entityType: 'client',
                entityId: '157ndqgx'
            },
            website: '—',
            totalFunding: '$300M',
            stages: 'Series E'
        },
        {
            client: {
                displayValue: 'Ambience Healthcare',
                entityType: 'client',
                entityId: '37xxdb7d'
            },
            website: '—',
            totalFunding: '$313M',
            stages: 'Series B, Series C'
        },
        {
            client: {
                displayValue: 'Affirm',
                entityType: 'client',
                entityId: '5kpo4z7r'
            },
            website: '—',
            totalFunding: '$375M',
            stages: 'Series B, Series D'
        },
        {
            client: {
                displayValue: 'Genesis Therapeutics',
                entityType: 'client',
                entityId: 'j8k3ozk2'
            },
            website: 'genesistherapeutics.ai',
            totalFunding: '$256M',
            stages: 'Seed, Series A, Series B'
        },
        {
            client: {
                displayValue: 'Capitolis',
                entityType: 'client',
                entityId: 'wogq3v7y'
            },
            website: '—',
            totalFunding: '$220M',
            stages: 'Series C, Series D, Unknown'
        },
        {
            client: {
                displayValue: 'Aleo',
                entityType: 'client',
                entityId: '297ewn7b'
            },
            website: '—',
            totalFunding: '$228M',
            stages: 'Series A, Series B'
        },
        {
            client: {
                displayValue: 'LayerZero Labs',
                entityType: 'client',
                entityId: 'zm7yxzg1'
            },
            website: '—',
            totalFunding: '$310M+',
            stages: 'Series A, Series B, Undisclosed'
        },
        {
            client: {
                displayValue: 'Valon',
                entityType: 'client',
                entityId: '297exykb'
            },
            website: 'valon.com',
            totalFunding: '$194M',
            stages: 'Series A, Series B, Series C'
        },
        {
            client: {
                displayValue: 'Substack',
                entityType: 'client',
                entityId: '1j7v6jg8'
            },
            website: 'substack.com',
            totalFunding: '$180M',
            stages: 'Series A, Series B, Series C'
        },
        {
            client: {
                displayValue: 'Material Security',
                entityType: 'client',
                entityId: 'w4kzpw7z'
            },
            website: '—',
            totalFunding: '$162M',
            stages: 'Seed, Series A, Series B, Series C'
        },
        {
            client: {
                displayValue: 'Character.ai',
                entityType: 'client',
                entityId: 'x7m33wg8'
            },
            website: 'character.ai',
            totalFunding: '$150M',
            stages: 'Series A'
        },
        {
            client: {
                displayValue: 'Point',
                entityType: 'client',
                entityId: '297ezn7b'
            },
            website: 'point.com',
            totalFunding: '$146M',
            stages: 'Series A, Series B, Series C'
        },
        {
            client: {
                displayValue: 'Anyscale',
                entityType: 'client',
                entityId: 'wp7w827v'
            },
            website: '—',
            totalFunding: '$160M',
            stages: 'Series A, Series B, Series C'
        },
        {
            client: {
                displayValue: 'Hebbia AI',
                entityType: 'client',
                entityId: '67ryyokn'
            },
            website: 'hebbia.ai',
            totalFunding: '$130M',
            stages: 'Series B'
        },
        {
            client: {
                displayValue: 'UnitedMasters',
                entityType: 'client',
                entityId: 'wq7dlygm'
            },
            website: '—',
            totalFunding: '$170M',
            stages: 'Series A, Series B, Series C'
        },
        {
            client: {
                displayValue: 'Snackpass',
                entityType: 'client',
                entityId: 'wq7doqgm'
            },
            website: '—',
            totalFunding: '$94M',
            stages: 'Series A, Series B'
        },
        {
            client: {
                displayValue: 'Silo',
                entityType: 'client',
                entityId: 'zr7owegb'
            },
            website: '—',
            totalFunding: '$101M',
            stages: 'Series A, Series B, Series C'
        },
        {
            client: {
                displayValue: 'Health IQ',
                entityType: 'client',
                entityId: 'j8k3vng2'
            },
            website: '—',
            totalFunding: '$90M',
            stages: 'Series C, Series D'
        },
        {
            client: {
                displayValue: 'Waymark',
                entityType: 'client',
                entityId: 'zr7ox27b'
            },
            website: 'waymarkcare.com',
            totalFunding: '$87M',
            stages: 'Series A, Unknown'
        },
        {
            client: {
                displayValue: 'Akasa',
                entityType: 'client',
                entityId: '3lkbmo7v'
            },
            website: '—',
            totalFunding: '$85M',
            stages: 'Seed, Series A, Series B'
        },
        {
            client: {
                displayValue: 'Memora Health',
                entityType: 'client',
                entityId: 'qxg29x7v'
            },
            website: '—',
            totalFunding: '$81M',
            stages: 'Unknown'
        },
        {
            client: {
                displayValue: 'SentiLink',
                entityType: 'client',
                entityId: 'b67rlv7n'
            },
            website: '—',
            totalFunding: '$84M',
            stages: 'Series A, Series B'
        },
        {
            client: {
                displayValue: 'Sprig (formerly Userleap)',
                entityType: 'client',
                entityId: 'qxg29v7v'
            },
            website: '—',
            totalFunding: '$68M',
            stages: 'Series B'
        },
        {
            client: {
                displayValue: 'Flock Homes',
                entityType: 'client',
                entityId: 'b9k4vrk4'
            },
            website: '—',
            totalFunding: '$69M',
            stages: 'Series A, Series B, Undisclosed, Unknown'
        },
        {
            client: {
                displayValue: 'Lumos',
                entityType: 'client',
                entityId: '9k4le174'
            },
            website: '—',
            totalFunding: '$65M',
            stages: 'Series A, Series B'
        },
        {
            client: {
                displayValue: 'AnyRoad',
                entityType: 'client',
                entityId: '1j7v2dk8'
            },
            website: '—',
            totalFunding: '$66M',
            stages: 'Series A, Series B'
        },
        {
            client: {
                displayValue: 'Method Financial',
                entityType: 'client',
                entityId: '5kpowv7r'
            },
            website: 'methodfi.com',
            totalFunding: '$58M',
            stages: 'Series A, Series B'
        },
        {
            client: {
                displayValue: 'Smartcar',
                entityType: 'client',
                entityId: 'j8k3plg2'
            },
            website: 'smartcar.com',
            totalFunding: '$60M',
            stages: 'Seed, Series A, Series B'
        },
        {
            client: {
                displayValue: 'LTSE',
                entityType: 'client',
                entityId: 'zm7y5zk1'
            },
            website: 'ltse.com',
            totalFunding: '$50M',
            stages: 'Series B'
        },
        {
            client: {
                displayValue: 'Krea',
                entityType: 'client',
                entityId: '4k9y46gd'
            },
            website: 'Krea.ai',
            totalFunding: '$80M',
            stages: 'Series A, Series B'
        },
        {
            client: {
                displayValue: 'Z League',
                entityType: 'client',
                entityId: '3lkbzrkv'
            },
            website: '—',
            totalFunding: '$52M',
            stages: 'Seed, Series A, Series B'
        },
        {
            client: {
                displayValue: 'SkySafe',
                entityType: 'client',
                entityId: 'l37xypkd'
            },
            website: 'skysafe.io',
            totalFunding: '$45M',
            stages: 'Seed, Series A, Series B'
        },
        {
            client: {
                displayValue: 'Orderful',
                entityType: 'client',
                entityId: 'r4k9prgd'
            },
            website: '—',
            totalFunding: '$44M',
            stages: 'Series A, Series B, Unknown'
        },
        {
            client: {
                displayValue: 'Sandbox VR',
                entityType: 'client',
                entityId: 'x978n17v'
            },
            website: '—',
            totalFunding: '$60M',
            stages: 'Series A, Series B'
        },
        {
            client: {
                displayValue: 'Raspberry AI',
                entityType: 'client',
                entityId: 'q71rlqgl'
            },
            website: '—',
            totalFunding: '$24M',
            stages: 'Series A'
        },
        {
            client: {
                displayValue: 'Black Forest Labs',
                entityType: 'client',
                entityId: '4kzy3y7z'
            },
            website: '—',
            totalFunding: '$30M',
            stages: 'Seed'
        },
        {
            client: {
                displayValue: 'Convex',
                entityType: 'client',
                entityId: 'l37xpqkd'
            },
            website: 'convex.dev',
            totalFunding: '$26M',
            stages: 'Series A'
        },
        {
            client: {
                displayValue: 'Adaptive',
                entityType: 'client',
                entityId: 'b1k54n73'
            },
            website: 'adaptive.build',
            totalFunding: '$31M',
            stages: 'Seed, Series A'
        },
        {
            client: {
                displayValue: 'Rutter',
                entityType: 'client',
                entityId: '1j7vdy78'
            },
            website: 'rutterapi.com',
            totalFunding: '$27M',
            stages: 'Series A'
        },
        {
            client: {
                displayValue: 'Yubico',
                entityType: 'client',
                entityId: 'x9782m7v'
            },
            website: 'yubico.com',
            totalFunding: '$25M+',
            stages: 'Unknown'
        },
        {
            client: {
                displayValue: 'Promptfoo',
                entityType: 'client',
                entityId: '978e917v'
            },
            website: 'promptfoo.dev',
            totalFunding: '$23M',
            stages: 'Seed, Series A'
        },
        {
            client: {
                displayValue: 'Maven',
                entityType: 'client',
                entityId: 'ygjeqy76'
            },
            website: 'maven.com',
            totalFunding: '$20M',
            stages: 'Series A'
        },
        {
            client: {
                displayValue: 'Nash',
                entityType: 'client',
                entityId: '5kporz7r'
            },
            website: 'nash.ai',
            totalFunding: '$28M',
            stages: 'Seed, Series A'
        },
        {
            client: {
                displayValue: 'CreatorDao',
                entityType: 'client',
                entityId: 'wp7wpvgv'
            },
            website: 'creatordao.com',
            totalFunding: '$20M',
            stages: 'Seed'
        },
        {
            client: {
                displayValue: 'Carbonated',
                entityType: 'client',
                entityId: '297e57bj'
            },
            website: '—',
            totalFunding: '$20M',
            stages: 'Seed, Series A'
        },
        {
            client: {
                displayValue: 'Spade',
                entityType: 'client',
                entityId: '1k5wpdk3'
            },
            website: 'spade.com',
            totalFunding: '$15M',
            stages: 'Seed, Series A'
        },
        {
            client: {
                displayValue: 'Tout',
                entityType: 'client',
                entityId: 'b1k58k38'
            },
            website: '—',
            totalFunding: '$15M',
            stages: 'Series B'
        },
        {
            client: {
                displayValue: 'OpenInvest',
                entityType: 'client',
                entityId: 'r4k9y3gd'
            },
            website: '—',
            totalFunding: '$14M',
            stages: 'Seed, Series A'
        },
        {
            client: {
                displayValue: 'Benchling',
                entityType: 'client',
                entityId: '157np5gx'
            },
            website: 'benchling.com',
            totalFunding: '$12M',
            stages: 'Seed, Series A'
        },
        {
            client: {
                displayValue: 'LootRush',
                entityType: 'client',
                entityId: 'b9k43d74'
            },
            website: 'lootrush.com',
            totalFunding: '$12M',
            stages: 'Seed'
        },
        {
            client: {
                displayValue: 'Intro',
                entityType: 'client',
                entityId: 'wq71m87l'
            },
            website: 'intro.co',
            totalFunding: '$10M',
            stages: 'Seed'
        },
        {
            client: {
                displayValue: 'Metaphor Data',
                entityType: 'client',
                entityId: '3lkb9vgv'
            },
            website: '—',
            totalFunding: '$10M',
            stages: 'Seed'
        },
        {
            client: {
                displayValue: 'Code Combat',
                entityType: 'client',
                entityId: '1j7vedk8'
            },
            website: '—',
            totalFunding: '$8M',
            stages: 'Seed, Series A'
        },
        {
            client: {
                displayValue: 'Flatiron Health',
                entityType: 'client',
                entityId: 'wogqrw7y'
            },
            website: '—',
            totalFunding: '$8M',
            stages: 'Series A'
        },
        {
            client: {
                displayValue: 'Beacons',
                entityType: 'client',
                entityId: 'wogqov7y'
            },
            website: 'beacons.ai',
            totalFunding: '$6M',
            stages: 'Seed'
        },
        {
            client: {
                displayValue: 'Queenly',
                entityType: 'client',
                entityId: 'oxk6vngj'
            },
            website: '—',
            totalFunding: '$6M',
            stages: 'Seed'
        },
        {
            client: {
                displayValue: 'Daze',
                entityType: 'client',
                entityId: 'l37x8qgd'
            },
            website: 'daze.nyc',
            totalFunding: '$11M',
            stages: 'Seed'
        },
        {
            client: {
                displayValue: 'Zarta',
                entityType: 'client',
                entityId: '3lkb137v'
            },
            website: 'zarta.com',
            totalFunding: '$6M',
            stages: 'Seed'
        },
        {
            client: {
                displayValue: 'ThirdLove',
                entityType: 'client',
                entityId: 'x9783okv'
            },
            website: '—',
            totalFunding: '$6M',
            stages: 'Seed'
        },
        {
            client: {
                displayValue: 'Biodock',
                entityType: 'client',
                entityId: 'b9k4mrk4'
            },
            website: 'biodock.ai',
            totalFunding: '$6M',
            stages: 'Pre-seed, Seed'
        },
        {
            client: {
                displayValue: 'Concourse',
                entityType: 'client',
                entityId: 'xk61r3gj'
            },
            website: 'concourse.co',
            totalFunding: '$5M',
            stages: 'Seed'
        },
        {
            client: {
                displayValue: 'Le Tote',
                entityType: 'client',
                entityId: '3x7mwk8y'
            },
            website: '—',
            totalFunding: '$13M',
            stages: 'Seed, Series C'
        },
        {
            client: {
                displayValue: 'Snapser',
                entityType: 'client',
                entityId: '97eqe57b'
            },
            website: 'snapser.com',
            totalFunding: '$3M',
            stages: 'Seed'
        },
        {
            client: {
                displayValue: 'Blend',
                entityType: 'client',
                entityId: 'b1k5pd73'
            },
            website: '—',
            totalFunding: 'Seed',
            stages: 'Seed'
        }
    ],
    sortableColumns: []
};

// Real data test: Candidates DQed in 'Being Scheduled' Stage for 'Gone Cold' - Web Crawler Engineer Role
const goneColdCandidatesTable: TableData = {
    columns: [
        {
            id: 'name',
            label: 'Name'
        },
        {
            id: 'linkedin',
            label: 'LinkedIn'
        },
        {
            id: 'disqualReason',
            label: 'DQ Reason'
        },
        {
            id: 'disqualifiedAt',
            label: 'DQ Date'
        },
        {
            id: 'lastEmailExchangedAt',
            label: 'Last Email'
        },
        {
            id: 'createdAt',
            label: 'Added to Job'
        }
    ],
    rows: [
        {
            name: {
                displayValue: 'Brian Chen',
                entityId: {
                    personId: '7n4oxx5y',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/brian-chen-a136ba194',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Nov 12, 2025',
            lastEmailExchangedAt: 'Oct 27, 2025',
            createdAt: 'Oct 20, 2025'
        },
        {
            name: {
                displayValue: 'Sean Erfurt',
                entityId: {
                    personId: '7ry3opnk',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/sean-erfurt',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Nov 8, 2025',
            lastEmailExchangedAt: 'Nov 3, 2025',
            createdAt: 'Oct 13, 2025'
        },
        {
            name: {
                displayValue: 'Ze Wang',
                entityId: {
                    personId: '7rl49m57',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/ze-wang-826712108',
            disqualReason: 'recruiter_declined_gone_cold',
            disqualifiedAt: 'Nov 6, 2025',
            lastEmailExchangedAt: 'Oct 23, 2025',
            createdAt: 'Oct 23, 2025'
        },
        {
            name: {
                displayValue: 'Jin Bak',
                entityId: {
                    personId: '4k9r12qk',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/jin-u-bak-7558842b',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Nov 5, 2025',
            lastEmailExchangedAt: 'Oct 24, 2025',
            createdAt: 'Oct 21, 2025'
        },
        {
            name: {
                displayValue: 'Zongmin Y.',
                entityId: {
                    personId: '7n2mzwq7',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/zongminyin',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Nov 4, 2025',
            lastEmailExchangedAt: 'Oct 20, 2025',
            createdAt: 'Oct 10, 2025'
        },
        {
            name: {
                displayValue: 'He Chen',
                entityId: {
                    personId: 'gqwwx9lg',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/he-chen-a591b674',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Nov 4, 2025',
            lastEmailExchangedAt: 'Oct 17, 2025',
            createdAt: 'Oct 14, 2025'
        },
        {
            name: {
                displayValue: 'Aditya Gurjar',
                entityId: {
                    personId: 'k42rmndg',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/adityagurjar08',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Nov 4, 2025',
            lastEmailExchangedAt: 'Oct 20, 2025',
            createdAt: 'Oct 10, 2025'
        },
        {
            name: {
                displayValue: 'Jerry Lee',
                entityId: {
                    personId: 'k619mr81',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/jerry-lee1999',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Nov 3, 2025',
            lastEmailExchangedAt: 'Oct 19, 2025',
            createdAt: 'Oct 10, 2025'
        },
        {
            name: {
                displayValue: 'Joseph Ayala',
                entityId: {
                    personId: '71pzx32x',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/joseph-ayala-b6986b204',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Nov 1, 2025',
            lastEmailExchangedAt: 'Oct 21, 2025',
            createdAt: 'Oct 9, 2025'
        },
        {
            name: {
                displayValue: 'Ashay Devanur',
                entityId: {
                    personId: 'k9yy4qzr',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/ashay-devanur',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Oct 31, 2025',
            lastEmailExchangedAt: 'Oct 20, 2025',
            createdAt: 'Oct 13, 2025'
        },
        {
            name: {
                displayValue: 'Zachary Marshall',
                entityId: {
                    personId: 'gjzo8657',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/zachbmarshall',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Oct 30, 2025',
            lastEmailExchangedAt: 'Oct 17, 2025',
            createdAt: 'Oct 8, 2025'
        },
        {
            name: {
                displayValue: 'Adam Arnon',
                entityId: {
                    personId: '71v59r27',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/adam-arnon',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Oct 29, 2025',
            lastEmailExchangedAt: 'Oct 21, 2025',
            createdAt: 'Oct 10, 2025'
        },
        {
            name: {
                displayValue: 'Shahin Rahbariasl',
                entityId: {
                    personId: 'kpoov28r',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/shahin-rahbariasl-b16b8210b',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Oct 29, 2025',
            lastEmailExchangedAt: 'Oct 21, 2025',
            createdAt: 'Oct 10, 2025'
        },
        {
            name: {
                displayValue: 'Chaitya Shah',
                entityId: {
                    personId: '7mn845nk',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/chaityashah',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Oct 28, 2025',
            lastEmailExchangedAt: 'Oct 13, 2025',
            createdAt: 'Oct 8, 2025'
        },
        {
            name: {
                displayValue: 'George Wang',
                entityId: {
                    personId: '7vvnrjd6',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/gtwang01',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Oct 23, 2025',
            lastEmailExchangedAt: 'Oct 8, 2025',
            createdAt: 'Oct 3, 2025'
        },
        {
            name: {
                displayValue: 'Mehran Banka',
                entityId: {
                    personId: 'k42pnr8x',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/mehran-banka',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Oct 23, 2025',
            lastEmailExchangedAt: 'Oct 8, 2025',
            createdAt: 'Oct 6, 2025'
        },
        {
            name: {
                displayValue: 'Kaisheng S.',
                entityId: {
                    personId: '7rpobr2k',
                    jobId: 'x7ml28g8'
                },
                entityType: 'candidate'
            },
            linkedin: 'www.linkedin.com/in/kaisheng-song',
            disqualReason: 'titan_declined_gone_cold',
            disqualifiedAt: 'Oct 22, 2025',
            lastEmailExchangedAt: 'Oct 14, 2025',
            createdAt: 'Oct 6, 2025'
        }
    ],
    sortableColumns: ['disqualifiedAt', 'lastEmailExchangedAt', 'createdAt'],
    title: "Candidates DQed in 'Being Scheduled' Stage for 'Gone Cold' - Web Crawler Engineer Role"
};

// ERROR TEST 1: Table with malformed columns (missing required fields)
const errorTest1MalformedColumns: TableData = {
    title: 'ERROR TEST: Malformed Columns',
    columns: [
        { id: 'name', label: 'Name' },
        null as any, // This will cause an error
        { id: 'value', label: 'Value' }
    ],
    rows: [
        { name: 'Test 1', value: 100 },
        { name: 'Test 2', value: 200 }
    ]
};

// ERROR TEST 2: Table with circular reference in rows
const createCircularTable = (): TableData => {
    const row: any = { name: 'Test', value: 100 };
    row.self = row; // Circular reference
    return {
        title: 'ERROR TEST: Circular Reference',
        columns: [
            { id: 'name', label: 'Name' },
            { id: 'value', label: 'Value' }
        ],
        rows: [row]
    };
};

// ERROR TEST 3: Table with undefined rows
const errorTest3UndefinedRows: TableData = {
    title: 'ERROR TEST: Undefined Rows',
    columns: [
        { id: 'name', label: 'Name' },
        { id: 'value', label: 'Value' }
    ],
    rows: undefined as any // This will cause an error
};

export const AgentTableTestPage: React.FC = () => {
    return (
        <div style={{ padding: '40px', background: '#f4f6f8', height: '100vh', overflow: 'auto' }}>
            <h1 style={{ marginBottom: '40px', color: '#333' }}>Table Feed Item Component Tests</h1>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>
                    Test 1: Candidates with Entity IDs (Sortable by Experience)
                </h2>
                <TableFeedPreview table={candidatesTable} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>Test 1: A16Z Clients</h2>
                <TableFeedPreview table={a16ztestTable} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>
                    Real Data: Gone Cold Candidates (Sortable by dates)
                </h2>
                <TableFeedPreview table={goneColdCandidatesTable} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>
                    Test 2: Jobs by Client (Sortable by Date and Count)
                </h2>
                <TableFeedPreview table={jobsTable} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>Test 3: Large Dataset (50 rows - pagination)</h2>
                <TableFeedPreview table={largeTable} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>
                    Test 4: Mixed Data Types (strings, numbers, booleans, nulls)
                </h2>
                <TableFeedPreview table={mixedDataTable} />
            </div>

            <div style={{ marginBottom: '60px', border: '2px solid #ff5722', padding: '20px', background: '#fff3e0' }}>
                <h2 style={{ color: '#d32f2f', marginBottom: '20px' }}>
                    🔥 ERROR TEST 1: Malformed Columns (should trigger error boundary)
                </h2>
                <TableFeedPreview table={errorTest1MalformedColumns} />
            </div>

            <div style={{ marginBottom: '60px', border: '2px solid #ff5722', padding: '20px', background: '#fff3e0' }}>
                <h2 style={{ color: '#d32f2f', marginBottom: '20px' }}>
                    🔥 ERROR TEST 2: Circular Reference (should trigger error boundary)
                </h2>
                <TableFeedPreview table={createCircularTable()} />
            </div>

            <div style={{ marginBottom: '60px', border: '2px solid #ff5722', padding: '20px', background: '#fff3e0' }}>
                <h2 style={{ color: '#d32f2f', marginBottom: '20px' }}>
                    🔥 ERROR TEST 3: Undefined Rows (should trigger error boundary)
                </h2>
                <TableFeedPreview table={errorTest3UndefinedRows} />
            </div>
        </div>
    );
};
